import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { SuiContainer, SuiTimePicker } from '@splashthat/sui';

import { containerPaddingXs } from 'common/styles/variables';

const LABEL_FROM = 'From';
const LABEL_TO = 'To';
const BASE_COMPONENT_NAME = 'TimeRangeControl';

const PaddedSmallSpacer = styled(SuiContainer)`
    padding: ${containerPaddingXs} 0;
`;

const TimeRangeControl = (props) => (
    <React.Fragment>
        <SuiTimePicker
            label={LABEL_FROM}
            onChange={(_, value) => props.onChangeTimeFrom(value)}
            value={props.timeFrom}
            data-qa={`${BASE_COMPONENT_NAME}__timeMin`}
            variation={props.error ? 'error' : ''}
        />
        <PaddedSmallSpacer />

        <SuiTimePicker
            label={LABEL_TO}
            onChange={(_, value) => props.onChangeTimeTo(value)}
            value={props.timeTo}
            data-qa={`${BASE_COMPONENT_NAME}__timeMax`}
            variation={props.error ? 'error' : ''}
        />
    </React.Fragment>
);

TimeRangeControl.propTypes = {
    timeTo: PropTypes.string,
    timeFrom: PropTypes.string,
    onChangeTimeFrom: PropTypes.func.isRequired,
    onChangeTimeTo: PropTypes.func.isRequired,
    error: PropTypes.bool,
};

TimeRangeControl.defaultProps = {
    timeTo: null,
    timeFrom: null,
    error: false,
};

export default TimeRangeControl;
